import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import GridRowLabel from '@/features/buybox/components/grid/GridRowLabel.vue';
import PreRollVideoAd from './components/PreRollVideoAd.vue';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { CatalogueItem } from '@/helpers/promotion-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'GridPreRollExp',
  props: {
    title: null,
    catalogueItem: null,
    providerShortName: null,
    shortName: null,
    isFreeBuyBox: { type: Boolean },
    additionalContexts: null,
    trackingContexts: null,
    seasonNumber: null,
    episodeNumber: null
  },
  setup(__props: any) {

const adFailed = ref(false);



return { __sfc: true,adFailed, GridRowLabel, PreRollVideoAd }
}

})